import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index3.js';
import { C as CURRENCY_MASK } from './form-input-masks.js';
import { K as inputGroup, l as label, J as inputAdornment, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlHelpText } from './form-control-help-text3.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';

const MonetaryInputProvisioning = /*@__PURE__*/ proxyCustomElement(class MonetaryInputProvisioning extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.isFocused = false;
        this.maskOptions = CURRENCY_MASK.DECIMAL;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, this.maskOptions);
            this.imask.on('accept', () => {
                const rawValue = this.imask.unmaskedValue;
                this.inputHandler(this.name, rawValue);
                this.formControlInput.emit({ name: this.name, value: rawValue });
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            const rawValue = this.imask.unmaskedValue;
            this.formControlInput.emit({ name: name, value: rawValue });
        };
        this.updateInput = (newValue) => {
            if (this.imask) {
                this.imask.value = String(newValue);
            }
        };
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.initializeIMask();
        this.updateInput(this.defaultValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    get inputPart() {
        let part = inputGroup;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        return (h(Host, { key: '950019f15743434eaa378b48338e73157525d677' }, h("div", { key: '9a4dab257ec7a62f3f3f1ba1cc2c4aad3f823c17', class: "form-group d-flex flex-column" }, h("label", { key: '19d046ba0d9f5d2b8fc7c3d8c1b9dc893a5834e5', part: label, class: "form-label", htmlFor: this.name }, this.label), h("div", { key: 'ba7df233aa5965ee0a7f5c01dfd84aabd3cecf70', class: "input-group" }, h("span", { key: 'e325e64173d5d7c260b824ef492f02f2333bdb8f', class: "input-group-text", part: inputAdornment }, "$"), h("input", { key: '5b1632e00657f9aa31139a9869ab63ad9388612e', ref: el => (this.textInput = el), id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.inputPart, class: this.errorText ? 'form-control monetary is-invalid' : 'form-control monetary', type: "text", disabled: this.disabled })), h(FormControlHelpText, { key: 'cb7f04dc7e6849d335eb0cfecfb05d7e0c26ff1f', helpText: this.helpText, name: this.name }), h(FormControlErrorText, { key: '6ad1b947a48e8c97a2f5a1c4c2c1094679ce25cd', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-monetary-provisioning", {
        "label": [1],
        "name": [1],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16, "input-handler"],
        "maskOptions": [8, "mask-options"],
        "disabled": [4],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-monetary-provisioning"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-monetary-provisioning":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MonetaryInputProvisioning);
            }
            break;
    } });
}
defineCustomElement();

export { MonetaryInputProvisioning as M, defineCustomElement as d };
